import React from 'react';
import { useTranslation } from 'react-i18next';
import { phoneMask } from '../../../../utils/masks-constants';
import { getDisplayableCNPJ } from '../../../../utils/cnpj-utils';
import IResumeProps from './interfaces/IResumeProps';
import IContact from '../../../interfaces/IContacts';
import renderContactType from '../../../../utils/contact-type-methods';

function Resume({ branchData, carrierContactData }: Readonly<IResumeProps>) {
    const { t } = useTranslation();
    const RESUME_TITLE = t('Resumo');
    const renderBasicInfo = () => {
        return (
            <>
                <h3> {t('InformacoesBasicas')} </h3>

                <h4>CNPJ</h4>
                <span>{getDisplayableCNPJ(branchData.cnpj)}</span>

                <h4>{t('RazaoSocial')}</h4>
                <span>{branchData.corporateName}</span>

                <h4>{t('PrazoPagamento')}</h4>
                <span>{branchData.paymentTerm} dias</span>
            </>
        );
    };

    const renderSystemInfo = () => {
        return (
            <>
                <h3> {t('DadoSistema')} </h3>

                <h4>{t('CodigoTms')}</h4>
                <span>{branchData.tmsCode}</span>

                <h4>{t('CodigoSap')} </h4>
                <span>{branchData.sapCode}</span>

                <h4>{t('CodigoEcc')}</h4>
                <span>{branchData.eccCode}</span>
            </>
        );
    };

    const renderCarrierContactInfo = () => {
        return (
            <>
                <h3> {t('InformacaoContatoMatriz')}</h3>

                <h4>{t('Telefone')} </h4>
                <span>{phoneMask(carrierContactData?.phone)}</span>

                <h4>{t('TipoTelefone')}</h4>
                <span>
                    {renderContactType(carrierContactData?.contactType)}
                </span>

                <h4>{t('Responsavel')}</h4>
                <span>{carrierContactData?.responsible}</span>

                <h4>{t('Funcao')}</h4>
                <span>{carrierContactData?.occupation}</span>
            </>
        );
    };

    const renderMainContact = () => {
        return (
            <>
                <h3> {t('InformacaoContatoPrincipal')}</h3>
                {renderContactInfo(branchData.mainContact)}
            </>
        );
    };

    const renderAdditionalContact = () => {
        return (
            <>
                <h3> {t('InformacaoContatoAdicional')}</h3>
                {branchData.additionalContacts?.map(
                    (currentElement: IContact, index: number) => {
                        return renderContactInfo(
                            currentElement,
                            `additional-contact-${index}`,
                        );
                    },
                )}
            </>
        );
    };

    const renderContactInfo = (contactInfo?: IContact, key?: string) => {
        return (
            <React.Fragment key={key}>
                <h4>{t('Email')}</h4>
                <span>{contactInfo?.email}</span>

                <h4>{t('Telefone')}</h4>
                <span>{phoneMask(contactInfo?.phone)}</span>

                <h4>{t('TipoTelefone')}</h4>
                <span>{renderContactType(contactInfo?.contactType)}</span>

                <h4>{t('Responsavel')}</h4>
                <span>{contactInfo?.responsible}</span>

                <h4>{t('Funcao')}</h4>
                <span>{contactInfo?.occupation}</span>
            </React.Fragment>
        );
    };

    const shouldRenderAdditionalContact =
        !branchData.additionalContacts ||
        branchData.additionalContacts.length === 0;

    return (
        <>
            <h1 className="resume-title">{RESUME_TITLE}</h1>
            <div className="resume-body">
                {renderBasicInfo()}
                {renderSystemInfo()}
                {renderCarrierContactInfo()}
                {renderMainContact()}
                {shouldRenderAdditionalContact && renderAdditionalContact()}
            </div>
        </>
    );
}

export default Resume;
